module.exports = __webpack_public_path__ + "img/ewizyta.c79768be.png";